
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";




import * as React from "react";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {ButtonProperties} from "InternalShared/PageBuilder/Controls/Properties/ButtonProperties";
import {FieldsProperty} from "InternalShared/PageBuilder/Controls/Properties/FieldsProperty";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {ImageProperty} from "InternalShared/PageBuilder/Controls/Properties/ImageProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {IconControlOptions, IconData} from "./IconControl.Options";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {IconDialog} from "PageBuilder/Dialogs/IconDialog";
import {FigureDialog} from "PageBuilder/Dialogs/FigureDialog";
import {FigureControlOptions} from "./FigureControl.Options";
import {FigureProperty} from "InternalShared/PageBuilder/Controls/Properties/FigureProperty";


declare let rednaoPDFInvoiceParams:any;





export class FigureControl extends PDFControlBase{
    public Options:FigureControlOptions;
    public Svg:any;
    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(async resolve => {
            let figure:IconData=await Dialog.Show(<FigureDialog/>);
            resolve(new FigureControlOptions().Merge({
                FigureData:figure,
                Styles:{
                    Width:'200px',
                    Height:'200px'
                }
            }))
        });
    }

    GetProperties(): GroupProperties[] {
        return [
            new GroupProperties('General').AddProperties([
                new FigureProperty(this,'FigureData')
            ])

        ];
    }

    GetStyles(): GroupProperties[] {
        return [
            DimensionStyleSet.GetStyles(this)
        ];
    }

    protected InternalGenerateHtml($container: JQuery<HTMLElement>) {

        this.Svg=jQuery(this.Options.FigureData.Svg);
        if(this.Options.FigureData.AllowColors) {
            this.Svg.attr('stroke',this.Options.Color);
            this.Svg.attr('fill',this.Options.Color);
        }
        $container.append(this.Svg);



        let $image=jQuery(`<img style="width: ${this.Options.Styles.Width};height:${this.Options.Styles.Height};"/>`);
        this.Options.Data=btoa(this.Svg[0].outerHTML);
        $image.attr('src','data:image/svg+xml;base64,'+this.Options.Data);

        this.Svg.replaceWith($image);
    }


    InternalAfterResize() {
        this.Refresh();
    }





}
